import get from 'lodash/get';

export default function(state = {}, action) {
  const typeMap = {
    AD_LOADED() {
      return {
        data: {
          [get(action, 'adName')]: get(action, 'status')
        }
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
